import * as React from 'react';
import * as toastr from 'toastr';

import UserDetailsForm from '../../user/UserDetailsForm';
import Button from '../../components/buttons/Button';

import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import { Validation, InputError, SecurityRoles as roles } from '../../common/utils';

interface Props {
	className?: string;
	customer: UserDetails;
	currentUser: UserDetails;
	actions: any;
	match?: any;
}
interface State {
	originalEmail?: string;
}
class CustomerDetailsPage extends React.Component<Props, State> {
	errors = {
		email: {} as InputError,
		mailingPostalCode: {} as InputError,
		billingPostalCode: {} as InputError
	};

	state = {
		originalEmail: this.props.customer.email
	};

	onUserChange = (e: any) => {
		const customer = {
			...this.props.customer,
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		};

		this.props.actions.setUser(customer);
	}

	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.props.customer.email),
			mailingPostalCode: Validation
				.validatePostalCode(this.props.customer.mailingPostalCode, 'Mailing postal code is not valid.'),
			billingPostalCode: Validation
				.validatePostalCode(this.props.customer.billingPostalCode, 'Billing postal code is not valid.')
		};
	}

	save = () => {
		const customer = { ...this.props.customer };
		if (customer.isSameAddress) {
			customer.billingAddress = customer.mailingAddress;
			customer.billingCity = customer.mailingCity;
			customer.billingProvince = customer.mailingProvince;
			customer.billingPostalCode = customer.mailingPostalCode;
			customer.billingCountry = customer.mailingCountry;
		}

		// We want to try to save first, if that works, then we want to update stripe.
		// Otherwise, there is a race condition, as well if there is an error saving
		// we'll have a bad time.
		this.props.actions.adminSaveUser(customer)
			.then((savedUser: UserDetails) => {
				if (this.state.originalEmail !== customer.email) {
					this.props.actions.updateStripeCustomerEmail(customer.stripeCustomerId, customer.email)
					.then((next: any) => {
						this.setState({ originalEmail: customer.email });
						toastr.success('Saved!');
					});
				}
				else {
					toastr.success('Saved!');
				}
			})
			.catch((error: any) => {
				toastr.error(error.response.data.responseStatus.message);
			});
	}

	isSaveDisabled = () => {
		if (this.errors.email.hasError ||
			this.errors.mailingPostalCode.hasError ||
			(!this.props.customer.isSameAddress && this.errors.billingPostalCode.hasError)
		) {
			return true;
		}

		return false;
	}

	render() {
		this.errors = this.validate();
		return (
			<div className={this.props.className}>
				<UserDetailsForm
					user={this.props.customer}
					currentUser={this.props.currentUser}
					onUserChange={this.onUserChange}
					errors={this.errors}
				/>
				<Button onClick={this.save} disabled={this.isSaveDisabled()} className="btn-primary mt-4">Save</Button>
			</div>
		);
	}
}
const adminRoles = [roles.Administrator, roles.Agent, roles.Adjudicator];
export default ensureUserHasRoleAdminSite(CustomerDetailsPage as any, adminRoles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerDetailsPage.tsx